/*
 * QuestionnairesDetail Messages
 *
 * This contains all the text for the QuestionnairesDetail container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'features.QuestionnairesDetail';

export default defineMessages({
  sendQuestionnaires: {
    id: `${scope}.sendQuestionnaires`,
    defaultMessage: 'Send Questionnaires',
  },
  sendInvite: {
    id: `${scope}.sendInvite`,
    defaultMessage: 'Send Invite',
  },
  youHaveSelected: {
    id: `${scope}.youHaveSelected`,
    defaultMessage: 'You have selected',
  },
  fName: {
    id: `${scope}.fName`,
    defaultMessage: 'First Name',
  },
  lName: {
    id: `${scope}.lName`,
    defaultMessage: 'Last Name',
  },
  sex: {
    id: `${scope}.sex`,
    defaultMessage: 'Sex',
  },
  birth: {
    id: `${scope}.birth`,
    defaultMessage: 'Birth',
  },
  email: {
    id: `${scope}.email`,
    defaultMessage: 'Email',
  },
  phNumber: {
    id: `${scope}.phNumber`,
    defaultMessage: 'Phone',
  },
  male: {
    id: `${scope}.male`,
    defaultMessage: 'Male',
  },
  female: {
    id: `${scope}.female`,
    defaultMessage: 'Female',
  },
  emptyGroup: {
    id: `${scope}.emptyGroup`,
    defaultMessage: 'Empty group',
  },
  members: {
    id: `${scope}.members`,
    defaultMessage: 'members(s)',
  },
});
